import React, {useRef} from 'react';
import Chart from 'chart.js/auto';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@material-ui/core';
import {useEffect, useState} from 'react';
import axios from "../api";
import Swal from "sweetalert2";


const Main = () => {
    const doughnutRef = useRef(null);
    const [femininoCount, setFemininoCount] = useState(0);
    const [masculinoCount, setMasculinoCount] = useState(0);
    const [outrosCount, setoutrosCount] = useState(0);
    const [results, setTableData] = useState([]);
    const [name, setName] = useState('');
    //constantes da tabela
    const rows = [
        {senha: 'senha', label: 'senha'},
        {nome: 'name', label: 'name'},
        {created_at: 'created_at', label: 'created_at '},
    ];

    //pega o me
    useEffect(() => {
        async function loadUser() {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get("me", {headers: {Authorization: `Bearer ${token}`}});
                setName(response.data.name);
            } catch (error) {
                console.log(error);
            }
        }

        loadUser();
    }, []);

//busca os dados de historico de senhas
    useEffect(() => {
        async function fetchData() {
            try {
                Swal.fire({
                    title: 'Carregando...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const token = localStorage.getItem('token');
                const response = await axios.get("senha", {headers: {Authorization: `Bearer ${token}`}});
                const results = response.data.data;
                if (results != null) {
                    Swal.close();
                    setTableData(results);
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: 'Não há histórico de senhas registradas nesta Unidade, verificar com seu administrador de sistemas.',
                });
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');

        // Faz a chamada HTTP para obter o número de pacientes femininos
        axios.get('/triagem/totalfeminino', {
            timeout: 10000,
            headers: {Authorization: `Bearer ${token}`}
        })
            .then(response => {
                setFemininoCount(response.data.total_feminino);
            })
            .catch(error => {
                console.log(error);
            });

        // Faz a chamada HTTP para obter o número de pacientes masculinos
        axios.get('/triagem/totalmasculinos', {
            timeout: 10000,
            headers: {Authorization: `Bearer ${token}`}
        })
            .then(response => {
                setMasculinoCount(response.data.total_masculinos);
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/triagem/totaloutros', {
            timeout: 10000,
            headers: {Authorization: `Bearer ${token}`}
        })
            .then(response => {
                setoutrosCount(response.data.outros);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);
    useEffect(() => {
        if (doughnutRef.current) {
            doughnutRef.current.destroy();
        }

        const ctx = document.getElementById('doughnutChart').getContext('2d');
        doughnutRef.current = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: ['Quantidade de mulheres', 'Quantidade de homens', 'Outros'],
                datasets: [
                    {

                        label: 'Dataset 1',
                        data: [femininoCount, masculinoCount, outrosCount],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.6)',
                            'rgba(54, 162, 235, 0.6)',
                            'rgb(197,197,197)',
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgb(101,100,100)',
                        ],
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: 'Gráfico de Rosca',
                    },
                },
                align: 'center'
            },
        });
    }, [femininoCount, masculinoCount]);

    return (
        <main style={{marginLeft: '250px', padding: '20px'}}>
            <h3>{`Bem-vindo, ${name}!`}</h3>
            <br/>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Card>
                        <CardHeader title="Registro de frequências na Unidade"/>
                        <CardContent className={"formularios"}>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        <canvas id="doughnutChart"
                                                style={{width: '80%', height: 'auto', marginLeft: '50´x'}}></canvas>
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6}>
                    <Card>
                        <CardHeader title="Histórico de senhas"/>
                        <CardContent>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
                                <TableContainer style={{width: '100%'}}>
                                    <Table style={{width: '100%', height: '4vh'}}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>Senha</strong></TableCell>
                                                <TableCell><strong>Nome do paciente</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {results.map((result) => (
                                                <TableRow key={result.id}>
                                                    <TableCell><strong>{result.senha}</strong></TableCell>
                                                    <TableCell>{result.name}</TableCell>
                                                </TableRow>
                                            ))} <TableBody>
                                        </TableBody>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </main>
    );
};

export default Main;
